import { render } from "./ProductAttributeCreateComponent.vue?vue&type=template&id=d0463a7a"
import script from "./ProductAttributeCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttributeCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductAttribute/ProductAttributeCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0463a7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0463a7a', __exports__)) {
    api.reload('d0463a7a', __exports__)
  }
  
  module.hot.accept("./ProductAttributeCreateComponent.vue?vue&type=template&id=d0463a7a", () => {
    api.rerender('d0463a7a', render)
  })

}


export default __exports__